import request from '@libs/base/request';

export const getListSchoolApi = async () =>
  request({
    url: '/v1/school',
    method: 'GET',
  });
